module.exports = __webpack_public_path__ + "img/carrito.f8c7aacc.svg";